import { z } from 'zod'

export const facilityPersonSchema = z.object({
  adult: z.coerce.number().nonnegative(),
  child: z.coerce.number().nonnegative(),
  infant: z.coerce.number().nonnegative(),
})

export type FacilityPerson = z.infer<typeof facilityPersonSchema>
